module.exports = __webpack_public_path__ + "static/media/scaled-xlarge.c016d94f.webp";